import { createScreenText } from 'helpers/screenText';
const st = createScreenText('ticket_lookup');

// src/pages/TicketLookup/types.ts
// Khớp với TicketLookupResponse từ backend (TicketService.Contacts.Dtos.TicketLookupResponse)

export interface TicketInfo {
  id: number;
  lotteryPeriodId: number;
  ticketNumber: string;
  symbol: string;
  seri?: string | null;
}

export interface PlanInfo {
  planCode: string;
  expectedDrawDate: string;
}

export interface WonPrize {
  prizeLevel: string;
  prizeAmount: number;
  winningNumber: string;
}

export interface ResultInfo {
  hasResult: boolean;
  isWinning: boolean;
  prizeLevel?: string | null;
  prizeAmount?: number | null;
  winningNumber?: string | null;
  drawStatus: 'pending' | 'completed' | string;
  actualDrawDate?: string | null;
  wonPrizes: WonPrize[];
}

export interface TicketLookupResponse {
  success: boolean;
  ticket?: TicketInfo | null;
  plan?: PlanInfo | null;
  result?: ResultInfo | null;
  errorCode?: string | null;
  errorMessage?: string | null;
  timestamp: string;
  requestId: string;
}

export const LOOKUP_ERROR_MESSAGES: Record<string, string> = {
  INVALID_SIGNATURE: st('ma_qr_khong_hop_le_hoac_text'),
  TICKET_NOT_FOUND: st('khong_tim_thay_thong_tin_ve_text'),
  INVALID_REQUEST: st('duong_dan_tra_cuu_khong_hop_text'),
  INTERNAL_ERROR: st('he_thong_dang_gap_su_co_text'),
};
